import { types } from '../constants'

const index = {
  pending: `${types.get}_PENDING`,
  fulfilled: `${types.get}_FULFILLED`,
  rejected: `${types.get}_REJECTED`
}

export const get = {
  [index.pending]: ({ draft }) => {
    draft.campaign.item.loading = true
  },
  [index.fulfilled]: ({ draft, action }) => {
    draft.campaign.item.data = action.payload
    draft.campaign.item.loading = false
  },
  [index.rejected]: ({ draft }) => {
    draft.campaign.item.loading = false
  }
}
